import './Filter.scss';

import { useDispatch } from "react-redux";

import { fetchFilterOptions } from "../../slices/filterOptionsSlice";

import { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";

import Search from "@mui/icons-material/Search";
import Cancel from "@mui/icons-material/Cancel";

import { IconButton } from "../Buttons/Buttons";

// export const Filter = ({propertyLabel, options, value, onChange}) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const dropdownRef = useRef(null);
//
//     useEffect(() => {
//         const handleClick = (e) => {
//             if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//                 setIsOpen(false)
//             }
//         };
//
//         document.addEventListener("mousedown", handleClick);
//         return () => {
//             document.removeEventListener("mousedown", handleClick);
//         }
//     }, []);
//
//     const toggleDropdown = () => {
//         setIsOpen((prevIsOpen) => !prevIsOpen);
//     }
//
//     const handleOptionClick = (option, e) => {
//         e.stopPropagation();
//         onChange(option.id);
//     }
//
//     const selectedOption = options.find(option => option.id === value) || null;
//
//     return (
//         <div className={"filter"} onClick={toggleDropdown} ref={dropdownRef}>
//             <div className={"filter_label"}>
//                 {selectedOption ? selectedOption.name : propertyLabel}
//             </div>
//             {isOpen && (
//                 <ul className={"filter_menu"}>
//                     {options.map((option) => (
//                         <li
//                             className={"filter_item"}
//                             key={option.id}
//                             onClick={(e) => handleOptionClick(option, e)}
//                         >
//                             {option.name}
//                         </li>
//                     ))}
//                 </ul>
//             )}
//         </div>
//     )
// }

export const Filter = ({ propertyLabel, options, value = [], onChange, fieldName, url, token, parentValue, parentFieldName }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();
    const initialUrl = useRef(url);

    useEffect(() => {
        const handleClick = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []);

    const toggleDropdown = () => {
        setIsOpen((prevIsOpen) => !prevIsOpen);
    };

    const handleOptionClick = (option, e) => {
        e.stopPropagation();
        onChange(option.id);
        setIsOpen(false);
    };

    const handleSearch = () => {
        if (!url) return;

        const urlObj = new URL(url, window.location.origin);

        if (parentFieldName && parentValue) {
            urlObj.searchParams.set(parentFieldName, parentValue);
        }

        urlObj.searchParams.set("search", searchValue);

        dispatch(fetchFilterOptions({
            fieldName,
            url: urlObj.toString(),
            token
        }));
    };

    const handleClear = () => {
        setSearchValue("");

        const urlObj = new URL(initialUrl.current, window.location.origin);
        if (parentFieldName && parentValue) {
            urlObj.searchParams.set(parentFieldName, parentValue);
        }

        dispatch(fetchFilterOptions({
            fieldName,
            url: urlObj.toString(),
            token
        }));
    };

    const selectedOption = options.find((option) => option.id === value) || null;

    return (
        <div className={"filter"} onClick={toggleDropdown} ref={dropdownRef}>
            <div className={"filter_label"}>
                {selectedOption ? selectedOption.name : propertyLabel}
            </div>
            {isOpen && (
                <div className="filter_menu" onClick={(e) => e.stopPropagation()}>
                    <div className="filter_search">
                        <div className="filter_search-wrapper">
                            <input
                                className="filter_search-input"
                                value={searchValue}
                                type="text"
                                placeholder="Поиск"
                                onChange={(e) => setSearchValue(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        handleSearch();
                                    }
                                }}
                            />
                            {searchValue && (
                                <button className="filter_search-clear" onClick={handleClear}>
                                    <Cancel style={{fontSize: "18px"}}/>
                                </button>
                            )}
                        </div>
                        <IconButton
                            Icon={Search}
                            color="#3C50E0"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleSearch();
                            }}
                        />
                    </div>

                    <ul>
                        {options.map((option) => (
                            <li
                                key={option.id}
                                className="filter_item"
                                onClick={(e) => handleOptionClick(option, e)}
                            >
                                {option.name}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export const MultiSelectFilter = ({
                                      propertyLabel,
                                      options,
                                      value = [],
                                      onChange,
                                      fieldName,
                                      url,
                                      token,
                                      parentValue,
                                      parentFieldName
                                  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const initialUrl = useRef(url);
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();

    useEffect(() => {
        const handleClick = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClick);

        return () => {
            document.removeEventListener("mousedown", handleClick);
        }
    }, [])

    const toggleDropdown = () => {
        setIsOpen((prevIsOpen) => !prevIsOpen);
    }

    const handleSearch = () => {
        if (!url) return;

        const urlObj = new URL(url, window.location.origin);

        if (parentFieldName && parentValue) {
            urlObj.searchParams.set(parentFieldName, parentValue);
        }

        urlObj.searchParams.set("search", searchValue);

        dispatch(fetchFilterOptions({
            filterKey: fieldName,
            url: urlObj.toString(),
            token
        }));
    };

    const handleClear = (e) => {
        e.stopPropagation();
        setSearchValue("");

        const urlObj = new URL(initialUrl.current, window.location.origin);
        if (parentFieldName && parentValue) {
            urlObj.searchParams.set(parentFieldName, parentValue);
        }

        dispatch(fetchFilterOptions({
            filterKey: fieldName,
            url: urlObj.toString(),
            token
        }));
    };

    const handleOptionClick = (option, e) => {
        e.stopPropagation();

        let newValue;

        if (value.includes(option.id)) {
            newValue = value.filter(item => item !== option.id);
        } else {
            newValue = [...value, option.id];
        }

        onChange([...newValue]);

        console.log("Value array:", value);
        console.log("Checking:", option.id, "Included?", value.includes(option.id));
        console.log("MultiSelectFilter - received value:", value);
    }

    const safeOptions = Array.isArray(options) ? options : [];
    const selectedOptions = safeOptions.filter(option => value.includes(option.id))
    const label = selectedOptions.length > 0 ? selectedOptions[0].name : propertyLabel;
    const extraCount = selectedOptions.length - 1;

    return (
        <div className={"filter"} onClick={toggleDropdown} ref={dropdownRef}>
            <div className={"filter_label"}>
                {label}
                {extraCount > 0 && (
                    <span className={"filter_badge"}>{`+${extraCount}`}</span>
                )}
            </div>
            {isOpen && (
                <div className="filter_menu" onClick={(e) => e.stopPropagation()}>
                    <div className="dropdown_search">
                        <div className="dropdown_search-wrapper">
                            <input
                                className="dropdown_search-input"
                                value={searchValue}
                                type="text"
                                placeholder="Поиск"
                                onChange={(e) => setSearchValue(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        handleSearch();
                                    }
                                }}
                            />
                            {searchValue && (
                                <button className="dropdown_search-clear" onClick={handleClear}>
                                    <Cancel style={{fontSize: "18px"}}/>
                                </button>
                            )}
                        </div>
                        <IconButton
                            Icon={Search}
                            color="#3C50E0"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleSearch();
                            }}
                        />
                    </div>

                    <ul>
                        {options.map((option) => (
                            <li
                                key={option.id}
                                className={`filter_item ${value.includes(option.id) ? "selected" : ""}`}
                                onClick={(e) => handleOptionClick(option, e)}
                            >
                                {option.name}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    )
}

export const DateRangeFilter = ({value, onChange}) => {

    const convertForInput = (dateStr) => {
        return dateStr ? dateStr.replace(' ', 'T') : '';
    }

    const convertForServer = (dateStr) => dateStr?.slice(0, 10) || '';

    const fromValue = value && value.from ? convertForInput(value.from) : '';
    const toValue = value && value.to ? convertForInput(value.to) : '';

    const handleFromChange = (e) => {
        const newFrom = convertForServer(e.target.value);
        onChange({from: newFrom, to: value?.to || ''});
    }

    const handleToChange = (e) => {
        const newTo = convertForServer(e.target.value);
        onChange({from: value?.from || '', to: newTo});
    }

    return (
        <div className={"date-range-filter"}>
            <div className={"date-range-filter_container"}>
                <div className={"date-range-filter_item"}>
                    <label className={"date-range-filter_label"}>
                        {""}
                    </label>
                    <input
                        className={"date-range-filter_input"}
                        type={"date"}
                        id={"date-from"}
                        value={fromValue}
                        onChange={handleFromChange}
                    />
                </div>
                <div className={"date-range-filter_item"}>
                    <label className={"date-range-filter_label"}>
                        {""}
                    </label>
                    <input
                        className={"date-range-filter_input"}
                        type={"date"}
                        id={"date-to"}
                        value={toValue}
                        onChange={handleToChange}
                    />
                </div>
            </div>
        </div>
    )
}